module.exports = __webpack_public_path__ + "static/img/crown.86bbae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crown.png
// module id = f2Ig
// module chunks = 6